<p-confirmDialog key="inventory-dialog">
  <ng-template pTemplate="header">
    <span data-testid="dialog-title" class="p-dialog-title">{{ title | translate }}</span>
  </ng-template>
  <ng-template pTemplate="message">
    @if (!sendEmail) {
      <div class="flex flex-col col-12 mb-2 text-wr">
        <!-- main content -->
        <p-table [columns]="tableColumns" [value]="data" (onLazyLoad)="customSort($event)" [lazy]="true" [customSort]="true">
          <ng-template #header let-columns>
            <tr>
              @for (col of columns; track col; let colIndex = $index) {
                <th [pSortableColumn]="col.field">
                  @if (colIndex !== columns.length-1) {
                    <div class="header-wr">
                      <span class="col-name">{{ ('TABLE.HEADER.' + col.header) | translate }}</span>
                      <p-sortIcon [field]="col.field"></p-sortIcon>
                    </div>
                  } @else {
                    {{ col.field }}
                  }
                </th>
              }
            </tr>
            <tr>
              @for (col of columns; track col; let colIndex = $index) {
                <th [attr.id]="col.field">
                  @if (colIndex !== columns.length-1;) {
                    <app-table-filter
                      [filterType]="col.filter"
                      [placeHolder]="'TABLE.FILTER.' + col.header"
                      [filterData]="col.filterData"
                    (onFilter)="filterEvent(col.filterField ?? col.field, $event, col.operator)"></app-table-filter>
                  }
                </th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              @for (col of columns; track col; let colIndex = $index) {
                <td
                  [ngClass]="{'actions-col': colIndex === columns.length -1}">
                  @if (colIndex !== columns.length-1) {
                    <span class="p-column-title">{{ ('TABLE.HEADER.' + col.header) | translate }}:</span>
                    {{ tableSettingService.getColumnValue(rowData, col) | defaultValue }}
                  } @else {
                    <div class="flex justify-center">
                      <span class="flex items-center mr-3" style="cursor: pointer"
                        pTooltip="{{ 'CUSTOMER_SINGLE_VIEW.TOOLTIP_EMAIL' | translate }}" tooltipPosition="top"
                        (click)="onOpenEmailModal($event, rowData)">
                        <i class="icon icon-email mr-1"></i>
                      </span>
                    </div>
                  }
                </td>
              }
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td [attr.colspan]="tableColumns?.length ?? 0">{{ 'ITEMS.NO_DATA' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </ng-template>
  <ng-template pTemplate="footer">
    <ng-container>
      <p-paginator (onPageChange)="onPageChange($event)" [first]="1" [rows]="pageSize"
        [totalRecords]="page.totalCount" showCurrentPageReport="true" [rowsPerPageOptions]="[5, 10, 20, 30]" />
    </ng-container>
  </ng-template>
</p-confirmDialog>

<!-- Modalbox: notificate retailer via email -->
<p-dialog [header]="'DIGITAL_CARDS.BTN_SEND_EMAIL' | translate" [(visible)]="displayEmailModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="true" [appendTo]="'body'"  [baseZIndex]="1200" class="compact-modal">
  <form [formGroup]="emailForm" (ngSubmit)="onSubmitEmailForm()" class="mt-0">
    <input type="hidden" id="id" formControlName="id">
    <div class="field-wr flex flex-col col-12">
      <label class="block text-sm" for="email">
        {{ 'MODALBOXES.EMAIL_RECIPIENT' | translate }}<i class="icon-required-field"></i>
      </label>
      <input type="text" id="email" formControlName="email" autocomplete="off">
      @if (emailForm.get('email')?.invalid && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)) {
        @if (emailForm.get('email')?.hasError('required')) {
          <small class="p-error">{{ 'MODALBOXES.EMAIL_REQUIRED' | translate }}</small>
        }
        @if (emailForm.get('email')?.errors?.['invalidEmail']) {
          <small class="p-error">
            {{
            'YOUR_ACCOUNT.VALIDATE_EMAIL_SYNTAX' | translate
            }}
          </small>
        }
      }
    </div>
  </form>

  <ng-template #footer>
    <button id="btn-cancel-email-card" type="button" class="btn outline-btn" (click)="onCancelEmailModal()">
      {{ 'MODALBOXES.BTN_CANCEL' | translate }}
    </button>
    <button id="btn-send-email-card" type="submit" class="btn primary-btn" [disabled]="emailForm.invalid"
      (click)="onSubmitEmailForm()">
      {{ 'MODALBOXES.BTN_SEND_EMAIL' | translate }}
    </button>
  </ng-template>
</p-dialog>
